<app-page-content>
  <ng-container title>{{ "Users.AddNewUser" | translate }}</ng-container>
    <mat-card class="card" content>
      <mat-card-content class="card-content">
        <app-user-form
          [userType]="userType"
          [id]="id"
          (close)="handleCloseEvent()"></app-user-form>
      </mat-card-content>
    </mat-card>
</app-page-content>
